import React, { useState, useEffect } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import TravelMobile from "@/assets/TravelMobile.svg";
import TravelDesktop from "@/assets/TravelDesktop.svg";
import BikeMobile from "@/assets/BikeMobile.svg";
import BikeDesktop from "@/assets/BikeDesktop.svg";
import SamsungMobile from "@/assets/SamsungMobile.svg";
import SamsungDesktop from "@/assets/SamsungDesktop.svg";

const mobileSlides = [SamsungMobile, TravelMobile, BikeMobile];
const desktopSlides = [SamsungDesktop, TravelDesktop, BikeDesktop];

export const LimitedOffers = () => {
  const [isDesktop, setIsDesktop] = useState(false);

  useEffect(() => {
    const update = () => setIsDesktop(window.innerWidth >= 768);
    update();
    window.addEventListener("resize", update);
    return () => window.removeEventListener("resize", update);
  }, []);
  const slides = isDesktop ? desktopSlides : mobileSlides;

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 5000,
    arrows: false,
    appendDots: (dots) => (
      <div
        style={{
          position: "absolute",
          ...(isDesktop && { bottom: "15px" }),
          width: "100%",
          display: "flex",
          justifyContent: "center",
        }}
      >
        <ul style={{ margin: 0, padding: 0, display: "flex", gap: "8px" }}>
          {dots}
        </ul>
      </div>
    ),
    customPaging: () => (
      <div
        style={{
          width: "16px",
          height: "4px",
          backgroundColor: "#71717B",
          borderRadius: "4px",
          transition: "all 0.3s ease",
        }}
      />
    ),
  };

  // Active dot: gold glow
  useEffect(() => {
    const style = document.createElement("style");
    style.innerHTML = `
      .slick-dots li.slick-active div {
        background-color: #DBAD71 !important;
        box-shadow: 0 4px 16px rgba(219,173,113,0.7) !important;
      }
    `;
    document.head.appendChild(style);
    return () => document.head.removeChild(style);
  }, []);

  return (
    <section className="w-full">
      <div className="h-12 md:h-[50px]" />
      <h2 className="text-xl md:text-6xl font-bold mb-4 md:mb-6 md:w-9/12">
        Limited Time Offers
      </h2>
      <div className="bg-[#DBAD71] w-[200px] h-[2px] md:h-[4px] mb-6 md:mb-10 rounded-full" />
      <div
        className="relative w-full"
      >
        <div
          className="absolute inset-x-0 bottom-0 h-32 pointer-events-none z-10"
          style={{ background: "linear-gradient(to top, rgba(0,0,0,0.45), transparent)" }}
        />

        <Slider {...settings}>
          {slides.map((slide, i) => (
            <div key={i}>
              <img
                src={slide}
                alt={`Limited Offer ${i + 1}`}
                className="w-full h-full object-contain md:object-cover"
                draggable={false}
              />
            </div>
          ))}
        </Slider>
      </div>
    </section>
  );
};